(function () {
  'use strict';

  var bar = document.getElementById('pdp-sticky-bar');
  if (!bar) return;

  // ATC-Hauptformular finden (action="/cart/add")
  var mainForm = document.querySelector('form[action="/cart/add"]');
  if (!mainForm) return;

  // Haupt-Varianten-Select finden
  var mainVariantSelect = mainForm.querySelector('[name="id"]');

  // Sticky Bar Select
  var barSelect = document.getElementById('pdp-sticky-bar-variant');

  // Preis-Element im Bar
  var barPrice = bar.querySelector('.pdp-sticky-bar__price');

  // Varianten-Daten aus Shopify global (via Liquid in Snippet)
  var variants = window.__pdpVariants || [];

  // Sticky Bar Variante -> Hauptform synchronisieren
  if (barSelect && mainVariantSelect) {
    barSelect.addEventListener('change', function () {
      mainVariantSelect.value = barSelect.value;
      // Shopify Varianten-Wechsel-Event triggern (fuer theme JS)
      mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      // Preis im Bar aktualisieren
      var selected = variants.find(function (v) {
        return String(v.id) === barSelect.value;
      });
      if (selected && barPrice) {
        barPrice.textContent = (selected.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
    });

    // Hauptform -> Sticky Bar synchronisieren (z.B. bei Swatch-Klick)
    mainVariantSelect.addEventListener('change', function () {
      barSelect.value = mainVariantSelect.value;
      // Preis im Bar synchron halten
      var selected = variants.find(function (v) {
        return String(v.id) === mainVariantSelect.value;
      });
      if (selected && barPrice) {
        barPrice.textContent = (selected.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
    });
  }

  // Haupt-ATC Button: dokument-weit suchen, da der echte Button AUSSERHALB von
  // mainForm liegen kann (Flow-Theme rendert ihn in einer separaten section).
  // Bevorzuge id-Praefix "ProductSubmitButton" (Shopify-Konvention), dann Klasse.
  var mainAtc = document.querySelector('[id^="ProductSubmitButton"]') ||
                document.querySelector('.product--add-to-cart-button');

  function showBar() {
    bar.classList.add('pdp-sticky-bar--visible');
    bar.removeAttribute('aria-hidden');
  }

  function hideBar() {
    bar.classList.remove('pdp-sticky-bar--visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  // Sichtbarkeits-Trigger: Bar erscheint sobald der Haupt-ATC-Button KOMPLETT
  // aus dem Viewport scrollt (threshold:0 = kein Pixel mehr sichtbar).
  if (mainAtc && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Button sichtbar -> Bar verstecken
            hideBar();
          } else if (entry.boundingClientRect.top < 0) {
            // Button komplett nach oben aus dem Viewport gescrollt -> Bar zeigen
            showBar();
          } else {
            // Button noch unterhalb des Folds (noch nicht erreicht) -> Bar verstecken
            hideBar();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainAtc);
  } else {
    // Fallback: scroll-basiert
    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 600) {
          showBar();
        } else {
          hideBar();
        }
      },
      { passive: true }
    );
  }

  // ATC Funktion - reicht den Submit an das Hauptformular weiter
  window.pdpStickyBarAdd = function () {
    if (mainForm) {
      var submitBtn = mainForm.querySelector('[name="add"], button[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
      }
    }
  };

  // Footer-Docking: Bar wird einmalig auf position:absolute umgestellt sobald der
  // Footer ins Viewport kommt. Kein per-Frame Layout-Write mehr -> kein Flicker.
  var footer = document.querySelector('.footer-main') || document.querySelector('footer');
  var isDocked = false;

  function dock() {
    if (!footer || isDocked) return;
    isDocked = true;
    // Dokument-Y-Koordinate der Footer-Oberkante (absolut im Dokument)
    var footerDocTop = footer.getBoundingClientRect().top + window.scrollY;
    var barH = bar.offsetHeight;
    bar.style.position = 'absolute';
    bar.style.top = (footerDocTop - barH) + 'px';
    bar.style.bottom = 'auto';
    bar.style.left = '0';
    bar.style.right = '0';
  }

  function undock() {
    if (!isDocked) return;
    isDocked = false;
    bar.style.position = '';
    bar.style.top = '';
    bar.style.bottom = '';
    bar.style.left = '';
    bar.style.right = '';
  }

  function checkDocking() {
    if (!footer) return;
    var footerTop = footer.getBoundingClientRect().top;
    var vh = window.innerHeight;
    if (footerTop < vh) {
      dock();
    } else {
      undock();
    }
  }

  var dockingRaf = null;

  window.addEventListener(
    'scroll',
    function () {
      if (dockingRaf !== null) return;
      dockingRaf = requestAnimationFrame(function () {
        checkDocking();
        dockingRaf = null;
      });
    },
    { passive: true }
  );

  window.addEventListener(
    'resize',
    function () {
      if (dockingRaf !== null) return;
      dockingRaf = requestAnimationFrame(function () {
        // Bei Resize Docking-State zuruecksetzen, damit Position neu berechnet wird
        isDocked = false;
        checkDocking();
        dockingRaf = null;
      });
    },
    { passive: true }
  );

  checkDocking();
})();

/* === pdp-tab-nav sticky logic === */
// PDP Anker-Tab-Navigation — Smooth-Scroll, Scroll-Spy, JS position:fixed sticky.
// Zusammengefuehrt aus separater Datei: neue Asset-Dateien werden per GitHub-Sync
// nicht zuverlaessig auf den Live-Shop uebertragen.
(function () {
  'use strict';

  var NAV_SEL = '[data-pdp-tab-nav]';
  var ITEM_SEL = '[data-pdp-tab]';
  var HEADER_SEL = '.site-header';
  var ACTIVE_CLASS = 'is-active';
  var FIXED_CLASS = 'is-fixed';

  function getHeaderBottom() {
    var header = document.querySelector(HEADER_SEL);
    if (!header) return 80;
    var bottom = header.getBoundingClientRect().bottom;
    return Math.max(0, bottom);
  }

  function injectMissingAnchors() {
    var appSection = document.getElementById('shopify-section-17690735720013f2ab');
    if (appSection && !document.getElementById('pdp-bewertungen')) {
      var span = document.createElement('span');
      span.id = 'pdp-bewertungen';
      span.className = 'pdp-anchor';
      appSection.insertBefore(span, appSection.firstChild);
    }
  }

  function init() {
    var nav = document.querySelector(NAV_SEL);
    if (!nav) return;

    injectMissingAnchors();

    var items = Array.from(nav.querySelectorAll(ITEM_SEL));

    // Spacer haelt den Platz im Fluss wenn nav auf fixed umschaltet (kein Layout-Shift)
    var spacer = document.createElement('div');
    spacer.className = 'pdp-tab-nav__spacer';
    spacer.style.display = 'none';
    nav.parentNode.insertBefore(spacer, nav);

    function getLastContentBottom() {
      var lastTarget = null;
      items.slice().reverse().some(function (item) {
        var id = item.getAttribute('data-pdp-tab');
        var el = document.getElementById(id);
        if (el) { lastTarget = el; return true; }
        return false;
      });
      if (!lastTarget) return Infinity;
      var ft = document.querySelector('.footer-main') || document.querySelector('footer');
      if (ft) return ft.getBoundingClientRect().top + window.scrollY;
      return lastTarget.getBoundingClientRect().top + window.scrollY + lastTarget.offsetHeight + 800;
    }

    // top/left/right der .is-fixed-Leiste werden jetzt rein per CSS gesetzt
    // (pdp-redesign.css: top: var(--sticky-header-desktop-height), left/right: 0
    // fuer full-bleed) statt hier per Inline-Style aus getBoundingClientRect()
    // nachgezogen zu werden -> kein Gap/Flackern mehr waehrend der
    // Header-Sticky-Transition, Hintergrund ist immer volle Viewportbreite.

    function applyFixed() {
      if (nav.classList.contains(FIXED_CLASS)) return;
      spacer.style.height = nav.offsetHeight + 'px';
      spacer.style.display = 'block';
      nav.classList.add(FIXED_CLASS);
    }

    function removeFixed() {
      if (!nav.classList.contains(FIXED_CLASS)) return;
      nav.classList.remove(FIXED_CLASS);
      spacer.style.display = 'none';
    }

    var stickyRaf = null;

    // Mobil (≤767px) ist die Nav per CSS auf position:static !important
    // gezwungen (siehe pdp-redesign.css) — das JS-Fixed-Positioning laeuft
    // dort ins Leere und verursacht nur unnoetiges Layout-Thrashing
    // (getBoundingClientRect/Style-Writes bei jedem Scroll/Resize). Branch
    // deshalb hinter einem Desktop-Check gaten; Scroll-Spy (IntersectionObserver)
    // und der Abo-Toggle weiter unten bleiben davon unberuehrt und laufen
    // mobil weiterhin normal.
    var desktopMQ = window.matchMedia('(min-width: 768px)');

    function updateSticky() {
      if (!desktopMQ.matches) {
        removeFixed();
        return;
      }
      var headerH = getHeaderBottom();
      var navH = nav.offsetHeight;
      var spacerRect = spacer.getBoundingClientRect();
      var navDocTop = (spacer.style.display === 'block')
        ? spacerRect.top
        : nav.getBoundingClientRect().top;
      var shouldFix = (navDocTop <= headerH);
      var lastBottomVP = getLastContentBottom() - window.scrollY;
      if (shouldFix && lastBottomVP <= headerH + navH) shouldFix = false;
      if (shouldFix) {
        applyFixed();
      } else {
        removeFixed();
      }
    }

    function onScrollOrResize() {
      if (stickyRaf !== null) return;
      stickyRaf = requestAnimationFrame(function () {
        updateSticky();
        stickyRaf = null;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    // Reagiert zusaetzlich auf Breakpoint-Wechsel ohne Resize-Event (z.B.
    // Chrome DevTools Device-Toolbar-Toggle); Fallback fuer aeltere Safari-
    // Versionen ohne addEventListener auf MediaQueryList.
    if (typeof desktopMQ.addEventListener === 'function') {
      desktopMQ.addEventListener('change', updateSticky);
    } else if (typeof desktopMQ.addListener === 'function') {
      desktopMQ.addListener(updateSticky);
    }

    updateSticky();

    // Mobil scrollt die Tab-Leiste horizontal (siehe pdp-redesign.css,
    // Mobile-Block "Scroll-Affordanz"). Ein Tab, der per Klick oder per
    // Scroll-Spy aktiv wird, kann dabei ausserhalb des sichtbaren
    // Ausschnitts liegen (z.B. "Haeufige Fragen" waehrend links noch
    // "Beschreibung" zu sehen ist) — centerActiveTab holt ihn in die Mitte.
    // Nur den horizontalen Scrollstand des Tab-Containers setzen, NICHT
    // scrollIntoView/window.scrollTo/.focus() verwenden — die bewegen trotz
    // block:'nearest' auch die Seite vertikal. Das erzeugte eine Rueckkopplungs-
    // schleife mit dem Scroll-Spy-IntersectionObserver (Ruecksprung zu
    // "Beschreibung" auf Mobile).
    function centerActiveTab(item) {
      if (!item) return;
      var inner = item.closest('.pdp-tab-nav__inner');
      if (!inner) return;
      if (inner.scrollWidth <= inner.clientWidth) return;
      var target = item.offsetLeft - (inner.clientWidth - item.offsetWidth) / 2;
      var max = inner.scrollWidth - inner.clientWidth;
      if (target < 0) target = 0;
      if (target > max) target = max;
      inner.scrollTo({ left: target, behavior: 'smooth' });
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var targetId = item.getAttribute('data-pdp-tab');
        var target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        var navH = nav.offsetHeight;
        var headerH = getHeaderBottom();
        var top = target.getBoundingClientRect().top + window.scrollY - headerH - navH;
        window.scrollTo({ top: top, behavior: 'smooth' });
        centerActiveTab(item);
      });
    });

    var anchors = items.map(function (item) {
      return document.getElementById(item.getAttribute('data-pdp-tab'));
    }).filter(Boolean);

    if (!anchors.length || !window.IntersectionObserver) return;

    var spyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          items.forEach(function (item) {
            var isNowActive = item.getAttribute('data-pdp-tab') === id;
            var wasActive = item.classList.contains(ACTIVE_CLASS);
            item.classList.toggle(ACTIVE_CLASS, isNowActive);
            // Beim Laden (erster Observer-Callback) und bei jedem Wechsel
            // waehrend des Scrollens den aktiven Tab in Sicht holen.
            if (isNowActive && !wasActive) { centerActiveTab(item); }
          });
        }
      });
    }, {
      rootMargin: '-' + (getHeaderBottom() + nav.offsetHeight) + 'px 0px -60% 0px',
      threshold: 0
    });

    anchors.forEach(function (anchor) { spyObserver.observe(anchor); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ASLAN Abo-Toggle: selling_plan input in product-form setzen
(function() {
  var purchaseType = document.querySelector('[data-aslan-purchase-type]');
  if (!purchaseType) return;
  var sellingPlansPanel = purchaseType.querySelector('[data-selling-plans]');
  var productForm = document.querySelector('form[action*="/cart/add"]');
  var sellingPlanInput;
  if (productForm) {
    sellingPlanInput = productForm.querySelector('input[name="selling_plan"][data-aslan-abo]');
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.setAttribute('data-aslan-abo', '');
      productForm.appendChild(sellingPlanInput);
    }
  }
  purchaseType.addEventListener('change', function(e) {
    var input = e.target;
    if (input.name === 'purchase_type') {
      var isSubscription = input.value === 'subscription';
      if (sellingPlansPanel) {
        sellingPlansPanel.hidden = !isSubscription;
        sellingPlansPanel.setAttribute('aria-hidden', String(!isSubscription));
      }
      if (!isSubscription && sellingPlanInput) { sellingPlanInput.value = ''; }
    }
    if (input.name === 'selling_plan' && sellingPlanInput) { sellingPlanInput.value = input.value; }
  });
})();
